import React, { useEffect, useState } from 'react';
import Switch from '@material-ui/core/Switch';
import { API_URL } from '../../../constants/API';

import './styles.css';

const pricing = {
  iconClass: 'far fa-lightbulb text-primary mr-1',
  preHeading: 'Flexible',
  preHeadingspan: 'Pricing',
  heading: 'Nuestros planes',
  headingText: ['Comenzá ahora a brindar un servicio que marca la diferencia.', '¡Probá gratis sin tarjeta de crédito!'],
  headingTextTwo: '¡Elegí tu plan! Probá gratis sin tarjeta de crédito',
  text: 'Los precios están expresados en pesos uruguayos ($UYU).<br>No se requiere tarjeta de crédito para comenzar el período de prueba.',
  plans: [
    {
      id: 1,
      name: '...',
      showAsRecommended: false,
      benefits: [
        {
          concept: 'Cargando...',
          enabled: true,
        },
      ],
      price: {
        UYU: 0,
        USD: 0,
        EUR: 0,
      },
      discount: {
        amount: 0,
        period: { unit: "month", value: 0 },
      },
    },
    {
      id: 2,
      name: '...',
      showAsRecommended: true,
      benefits: [
        {
          concept: 'Cargando...',
          enabled: true,
        },
      ],
      price: {
        UYU: 0,
        USD: 0,
        EUR: 0,
      },
      discount: {
        amount: 100,
        period: { unit: "month", value: 1 },
      },
    },
    {
      id: 3,
      name: '...',
      showAsRecommended: false,
      benefits: [
        {
          concept: 'Cargando...',
          enabled: true,
        },
      ],
      price: {
        UYU: 0,
        USD: 0,
        EUR: 0,
      },
      discount: {
        amount: 0,
        period: { unit: "month", value: 0 },
      },
    },
  ],
};

const PricingSection = () => {
  const [yearly, setYearly] = useState(true);
  const [pricingData, setPricingData] = useState(pricing);

  const scrollToElement = (ev) => {
    ev.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const highlightConcept = (input) => {
    let output = input;
    output = output.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    output = output.replace(/~~(.*?)~~/g, '<span style="color: red; font-size: 1.2em;">$1</span>')

    return output;
  }

  useEffect(() => {
    fetch(`${API_URL}/payments/plans`)
      .then((response) => response.json())
      .then((data) => {
        setPricingData({
          ...pricingData,
          plans: [
            ...data
              .filter((plan) => plan.active)
              .map((plan) => ({
                ...plan,
                benefits: JSON.parse(plan.benefits),
                price: JSON.parse(plan.price),
              })),
          ],
        });
      });
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const featuredElement = document.querySelector('.featured');

    if (mediaQuery.matches && featuredElement) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.scrollIntoView({ behavior: 'smooth' });
            }
          });
        },
        {
          root: null, // El viewport
          rootMargin: '0px',
          threshold: 0.01 // El porcentaje del elemento que debe estar visible para activar el callback
        }
      );

      observer.observe(featuredElement);

      // Limpia el observer al desmontar el componente
      return () => observer.disconnect();
    }
  }, []);

  return (
    <section
      id="pricing"
      className="section price-plan-area bg-gray overflow-hidden ptb_100"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-7">
            {/* Section Heading */}
            <div className="section-heading text-center">
              <h2>{pricing.heading}</h2>
              <p className="d-none d-sm-block my-4">
                {pricing.headingText.map((text, index) => (
                  <React.Fragment key={index}>
                    {text}
                    {index < pricing.headingText.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </p>
              <p className="d-block d-sm-none my-4">
                {pricing.headingTextTwo}
              </p>
              <span className={[
                'price-mode',
                !yearly ? 'selected' : '',
              ].join(' ')}>Mensual</span>
              <Switch
                size="medium"
                checked={yearly}
                className={[
                  'pricing',
                  yearly ? 'yearly' : 'monthly',
                ].join(' ')}
                onChange={(ev) => setYearly(ev.target.checked)}
              />
              <span className={[
                'price-mode',
                yearly ? 'selected' : '',
              ].join(' ')}>Anual <sup>Ahorrás hasta un 30%</sup></span>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-sm-12 col-lg-12">
            <div className="row price-plan-wrapper">
              {pricingData.plans.map((plan, idx) => {
                return (
                  <div
                    key={`p_${idx}`}
                    className={[
                      'col-12 col-md-4 mt-2 p-0',
                      plan.showAsRecommended ? 'featured' : '',
                    ].join(' ')}
                    onClick={scrollToElement}
                  >
                    {/* Single Price Plan */}
                    <div className="single-price-plan text-center p-5">
                      {/* Plan Thumb */}
                      {/* Plan Title */}
                      <div className="plan-title my-2 my-sm-3">
                        <h3 className="text-uppercase" style={{ color: "#f9b302" }}>
                          {plan.name}
                        </h3>
                      </div>
                      {/* Plan Price */}
                      <div className="plan-price pb-2 pb-sm-3">
                        <h1 className="color-primary">
                          <small className="fw-7">
                            $UYU
                          </small>
                          {yearly ? Math.round((plan.price.UYU * 10) / 12) : plan.price.UYU}
                          <small
                            style={{
                              fontSize: 18,
                              fontWeight: 'bold',
                            }}
                          >
                            /mes
                          </small>
                          {yearly && <p>
                            <small className="fw-7">Un pago anual de $UYU {Math.round((plan.price.UYU * 10)).toFixed(2)}</small>
                          </p>}
                        </h1>
                      </div>
                      {/* Plan Description */}
                      <div className="plan-description">
                        <ul className="plan-features">
                          {plan.benefits.map((benefit, index) => {
                            if (benefit.enabled) {
                              return (
                                <li
                                  key={index}
                                  className={[
                                    'border-top py-3',
                                    index == 5 &&
                                    'border-bottom py-3',
                                  ].join(' ')}
                                  style={{ color: '#000000' }}
                                >
                                  <i
                                    className="fas fa-check"
                                    style={{
                                      marginRight: 8,
                                      color: '#43a047',
                                    }}
                                  ></i>
                                  <span
                                    dangerouslySetInnerHTML={{ __html: highlightConcept(benefit.concept) }}
                                  />
                                </li>
                              );
                            } else {
                              return (
                                <li
                                  key={index}
                                  className={[
                                    'border-top py-3',
                                    index == 5 &&
                                    'border-bottom py-3',
                                  ].join(' ')}
                                  style={{
                                    color: '#D0D0D0',
                                    textDecoration: 'line-through',
                                  }}
                                  dangerouslySetInnerHTML={{ __html: highlightConcept(benefit.concept) }}
                                />
                              );
                            }
                          })}
                          <li
                            className={'border-top py-4'}
                            style={{ color: '#000000' }}
                          >
                            <h3 className="mb-3">¡Contratalo ahora!</h3>
                            <a href={`https://portal.deminut.com.uy/?plan=${plan.id}&frequency=${yearly ? 'annual' : 'monthly'}`} className="btn">¡Lo quiero!</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="row pt-5 pb-4" style={{ display: 'flex', justifyContent: 'center' }}>
          <strong
            className="pt-4"
            style={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={{ __html: highlightConcept(pricing.text) }}
          />
        </div>
        <div style={{ textAlign: 'center' }}>
          <p>
            <span style={{ color: "red", fontSize: "1.2em", marginRight: ".3em" }}>*</span>
            Después de registrarte, te escribimos para coordinar juntos la impresión y el envío de tus códigos QR.
          </p>
          <p>
            <span style={{ color: "red", fontSize: "1.2em", marginRight: ".3em" }}>*</span>
            Los pedidos extra diarios tienen una pequeña comisión adicional.
          </p>
          <p>
            <span style={{ color: "red", fontSize: "1.2em", marginRight: ".3em" }}>*</span>
            Atención prioritaria y respuestas súper rápidas cuando más lo necesitás.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
